import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export const SkeletonPagePDF = () => (
  <Skeleton height={600} variant="rect" width="100%" />
);